export const environment = {
  production: false,
  baseUrl: 'https://test.mentahealth.app/',
  apiUrl: 'https://test.mentahealth.app/api/gql/',
};
